import BaseUseCase from "../../../base_use_case.js";

class SaveProjectUseCase extends BaseUseCase {

  execute(identifier, params) {
    let url = identifier ? `/api/v1/admin/projects/projects/${identifier}` : `/api/v1/admin/projects/projects`;

    let wrappedParams = this.wrapParams(params, "project");
    wrappedParams.findBySlug = true;

    return this.httpClient({
      ...this.requestConfig(),
      method: identifier ? "put" : "post",
      url: url,
      data: wrappedParams,
    });
  }
}

const instance = new SaveProjectUseCase();
export default instance;